













































import { Component, Mixins, Emit, Watch } from "vue-property-decorator";
import { RegularExpressionUtility } from "../../../utilities";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter, RegExpFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatReferenceFilterParameter } from ".";
import Enumerable from "linq";

@Component({
  components: {
    StringFilter,
  },
})
export default class FormatReferenceMasterCodeFilter extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      editingMasterCodeFirst: new StringFilterParameter(),
      editingMasterCodeSecond: new StringFilterParameter(),
      editingMasterCodeThird: new StringFilterParameter(),
      isPrefixListActive: false,
    };
  }
  editingMasterCodeFirst: StringFilterParameter;
  editingMasterCodeSecond: StringFilterParameter;
  editingMasterCodeThird: StringFilterParameter;
  editingSource: FormatReferenceFilterParameter;
  isPrefixListActive: boolean;

  $refs!: {
    masterCodeFirst: StringFilter,
    masterCodeSecond: StringFilter,
    masterCodeThird: StringFilter,
  };

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: FormatReferenceFilterParameter, oldValue: FormatReferenceFilterParameter) {
    if (newValue && oldValue && newValue.masterCode.regExp !== oldValue.masterCode.regExp && newValue.masterCode.regExp === null) {
      // 基本的に上位からパラメータを更新されることはないが、クリアされたときは空にする必要がある
      this.editingMasterCodeFirst = new StringFilterParameter();
      this.editingMasterCodeSecond = new StringFilterParameter();
      this.editingMasterCodeThird = new StringFilterParameter();
    }
    this.updateMasterCodeText();
  }

  get masterCode(): RegExpFilterParameter {
    return this.editingSource.masterCode;
  }

  set masterCode(source: RegExpFilterParameter) {
    this.writeProperty(s => s.masterCode = source);
  }

  get masterCodeFirst(): StringFilterParameter {
    return this.editingMasterCodeFirst;
  }

  set masterCodeFirst(source: StringFilterParameter) {
    this.editingMasterCodeFirst = source;
    this.updateMasterCode();
  }

  get masterCodeSecond(): StringFilterParameter {
    return this.editingMasterCodeSecond;
  }

  set masterCodeSecond(source: StringFilterParameter) {
    this.editingMasterCodeSecond = source;
    this.updateMasterCode();
  }

  get masterCodeThird(): StringFilterParameter {
    return this.editingMasterCodeThird;
  }

  set masterCodeThird(source: StringFilterParameter) {
    this.editingMasterCodeThird = source;
    this.updateMasterCode();
  }

  private updateMasterCode(): void {
    const pattern = "(.*"
      + RegularExpressionUtility.escape(this.masterCodeFirst.keyword)
      + ".*)-(.*"
      + RegularExpressionUtility.escape(this.masterCodeSecond.keyword)
      + ".*)-(.*"
      + RegularExpressionUtility.escape(this.masterCodeThird.keyword)
      + ".*)";
    this.masterCode = new RegExpFilterParameter(new RegExp(pattern, "i"));
  }

  async onEnterTextMasterCodeFirst(): Promise<void> {
    await this.$nextTick();
    this.$refs.masterCodeSecond.focus();
  }

  async onEnterTextMasterCodeSecond(): Promise<void> {
    await this.$nextTick();
    this.$refs.masterCodeThird.focus();
  }

  @Emit("updateText")
  updateMasterCodeText(): string {
    return this.masterCodeFirst.keyword !== "" || this.masterCodeSecond.keyword !== "" || this.masterCodeThird.keyword !== ""
      ? this.masterCodeFirst.keyword + "-" + this.masterCodeSecond.keyword + "-" + this.masterCodeThird.keyword
      : "";
  }

  get masterCodePrefixes(): string[] {
    return Enumerable.from(this.$configuration.behavior.format.option.masterCodePrefixes)
      .select(p => p.prefix)
      .toArray();
  }

  onMasterCodeFirstInputMouseDown(): void {
    this.isPrefixListActive = !this.isPrefixListActive;
  }

  onMasterCodeFirstInputBlur(): void {
    this.isPrefixListActive = false;
  }

  get shouldShowPrefixList(): boolean {
    return this.isPrefixListActive && this.masterCodePrefixes.length !== 0;
  }

  onPrefixListBlur(): void {
    this.isPrefixListActive = false;
  }

  getPrefixListClassName(index: number): string {
    const prefix = this.masterCodePrefixes[index];
    return this.masterCodeFirst.keyword === prefix
      ? "list-selected"
      : "list-unselected";
  }

  onPrefixListMouseDown(index: number): void {
    const prefix = this.masterCodePrefixes[index];
    if (!prefix || this.masterCodeFirst.keyword === prefix) { return; }
    this.masterCodeFirst =  new StringFilterParameter(prefix, false);

    // ツリーの再描画か何かでフォーカスを奪われてしまうので、遅らせてフォーカスを当てている
    this.$nextTick(() => {
      setTimeout(() => this.$refs.masterCodeFirst.focus());
    });
  }
}
